module.exports = __webpack_public_path__ + "img/Polygon 9.97996fa7.png";